import React, { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './Profile.css';

const Profile = () => {
  const { user, updateProfile, updatePassword, logout } = useContext(AuthContext);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: user?.name || '',
    email: user?.email || '',
    phoneNumber: user?.phoneNumber || '',
    personalNumber: user?.personalNumber || '',
  });
  const [formError, setFormError] = useState('');
  const [formSuccess, setFormSuccess] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);


  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [passwordData, setPasswordData] = useState({
    passwordCurrent: '',
    password: '',
    passwordConfirm: ''
  });
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState('');
  const [isPasswordSubmitting, setIsPasswordSubmitting] = useState(false);

  const { passwordCurrent, password, passwordConfirm } = passwordData;


  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('ar-EG', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const { name, email, phoneNumber, personalNumber } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setFormError('');
    setFormSuccess('');
    setIsSubmitting(true);

    if (!name || !email || !phoneNumber || !personalNumber) {
      setFormError('الرجاء إدخال جميع البيانات المطلوبة');
      setIsSubmitting(false);
      return;
    }

    const result = await updateProfile(formData);

    if (result.error) {
      setFormError(result.error);
    } else {
      setFormSuccess('تم حفظ التغييرات بنجاح');
    }

    setIsSubmitting(false);
    setIsSubmitting(false);
  };

  const onPasswordChange = (e) => {
    setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
  };

  const onPasswordSubmit = async (e) => {
    e.preventDefault();
    setPasswordError('');
    setPasswordSuccess('');
    setIsPasswordSubmitting(true);

    if (password !== passwordConfirm) {
      setPasswordError('كلمة المرور الجديدة وتأكيدها غير متطابقين');
      setIsPasswordSubmitting(false);
      return;
    }

    if (password.length < 8) {
      setPasswordError('كلمة المرور يجب أن تكون 8 أحرف على الأقل');
      setIsPasswordSubmitting(false);
      return;
    }

    const result = await updatePassword({
      passwordCurrent,
      password
    });

    if (result.error) {
      setPasswordError(result.error);
    } else {
      setPasswordSuccess('تم تغيير كلمة المرور بنجاح');
      setPasswordData({ passwordCurrent: '', password: '', passwordConfirm: '' });
      setTimeout(() => {
        setPasswordSuccess('');
        setShowPasswordForm(false);
      }, 2000);
    }

    setIsPasswordSubmitting(false);
  };

  const handleLogout = () => {
    if (window.confirm(t('profile.logoutConfirm'))) {
      logout();
      navigate('/');
    }
  };

  return (
    <div className="profile-page-container">
      { }
      <div className="profile-page-header">
        <div className="container">
          <div className="profile-breadcrumb">الرئيسية / حسابي</div>
          <h1 className="profile-title">إعدادات الحساب</h1>
        </div>
      </div>

      <div className="container">
        <div className="row">
          { }
          <div className="col-lg-4">
            <div className="pro-card">
              <div className="pro-card-body">
                <div className="user-summary-avatar">
                  {user?.name ? user.name.charAt(0).toUpperCase() : <i className="fas fa-user"></i>}
                </div>
                <h3 className="user-summary-name">{user?.name}</h3>
                <span className="user-summary-role">
                  {user?.role === 'admin' ? 'مدير النظام' : 'عضو مسجل'}
                </span>

                <div className="mt-4">
                  <div className="info-list-item">
                    <span className="info-label">رقم العضوية (CPR)</span>
                    <span className="info-value">{user?.personalNumber || 'غير محدد'}</span>
                  </div>
                  <div className="info-list-item">
                    <span className="info-label">تاريخ الانضمام</span>
                    <span className="info-value">{formatDate(user?.createdAt)}</span>
                  </div>
                  <div className="info-list-item">
                    <span className="info-label">حالة الحساب</span>
                    <span className="badge bg-success bg-opacity-10 text-success rounded-pill px-3">نشط</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          { }
          <div className="col-lg-8">
            <div className="pro-card">
              <div className="pro-card-header">
                <h4 className="pro-card-title">البيانات الشخصية</h4>
              </div>
              <div className="pro-card-body">

                {formError && (
                  <div className="alert-modern alert-modern-danger">
                    <i className="fas fa-exclamation-circle me-2"></i>
                    {formError}
                  </div>
                )}

                {formSuccess && (
                  <div className="alert-modern alert-modern-success">
                    <i className="fas fa-check-circle me-2"></i>
                    {formSuccess}
                  </div>
                )}

                <form onSubmit={onSubmit}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group-modern">
                        <label htmlFor="name" className="form-label-modern">الاسم الكامل</label>
                        <input
                          type="text"
                          className="input-modern"
                          id="name"
                          name="name"
                          value={name}
                          onChange={onChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group-modern">
                        <label htmlFor="email" className="form-label-modern">البريد الإلكتروني</label>
                        <input
                          type="email"
                          className="input-modern"
                          id="email"
                          name="email"
                          value={email}
                          onChange={onChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group-modern">
                        <label htmlFor="phoneNumber" className="form-label-modern">رقم الهاتف</label>
                        <input
                          type="tel"
                          className="input-modern"
                          id="phoneNumber"
                          name="phoneNumber"
                          value={phoneNumber}
                          onChange={onChange}
                          dir="ltr"
                          style={{ textAlign: 'right' }}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group-modern">
                        <label htmlFor="personalNumber" className="form-label-modern">الرقم الشخصي (CPR)</label>
                        <input
                          type="text"
                          className="input-modern"
                          id="personalNumber"
                          name="personalNumber"
                          value={personalNumber}
                          onChange={onChange}
                          placeholder="الرجاء إدخال الرقم الشخصي"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-end mt-4">
                    <button type="submit" className="btn-modern-primary" disabled={isSubmitting}>
                      {isSubmitting ? <span className="loading-spinner ms-2"></span> : null}
                      {isSubmitting ? 'جاري الحفظ...' : 'حفظ التغييرات'}
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="pro-card">
              <div className="pro-card-header">
                <h4 className="pro-card-title">إعدادات الأمان</h4>
              </div>
              <div className="pro-card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="fw-bold mb-1">كلمة المرور</h6>
                    <p className="text-muted mb-0 small">ينصح بتغيير كلمة المرور بشكل دوري</p>
                  </div>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => setShowPasswordForm(!showPasswordForm)}
                  >
                    {showPasswordForm ? 'إلغاء' : 'تغيير كلمة المرور'}
                  </button>
                </div>

                {showPasswordForm && (
                  <div className="mt-4 pt-3 border-top">
                    {passwordError && (
                      <div className="alert-modern alert-modern-danger mb-3">
                        <i className="fas fa-exclamation-circle me-2"></i>
                        {passwordError}
                      </div>
                    )}

                    {passwordSuccess && (
                      <div className="alert-modern alert-modern-success mb-3">
                        <i className="fas fa-check-circle me-2"></i>
                        {passwordSuccess}
                      </div>
                    )}

                    <form onSubmit={onPasswordSubmit}>
                      <div className="form-group-modern mb-3">
                        <label className="form-label-modern">كلمة المرور الحالية</label>
                        <input
                          type="password"
                          className="input-modern"
                          name="passwordCurrent"
                          value={passwordCurrent}
                          onChange={onPasswordChange}
                          required
                        />
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group-modern mb-3">
                            <label className="form-label-modern">كلمة المرور الجديدة</label>
                            <input
                              type="password"
                              className="input-modern"
                              name="password"
                              value={password}
                              onChange={onPasswordChange}
                              minLength="8"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group-modern mb-3">
                            <label className="form-label-modern">تأكيد كلمة المرور الجديدة</label>
                            <input
                              type="password"
                              className="input-modern"
                              name="passwordConfirm"
                              value={passwordConfirm}
                              onChange={onPasswordChange}
                              minLength="8"
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="text-end">
                        <button type="submit" className="btn-modern-primary" disabled={isPasswordSubmitting}>
                          {isPasswordSubmitting ? <span className="loading-spinner ms-2"></span> : null}
                          حفظ كلمة المرور
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {!showPasswordForm && (
                  <div className="mt-3 text-muted small">
                    <i className="fas fa-info-circle me-1"></i>
                    تأكد من اختيار كلمة مرور قوية تحتوي على أحرف وأرقام.
                  </div>
                )}
              </div>
            </div>

            <div className="pro-card">
              <div className="pro-card-header">
                <h4 className="pro-card-title">{t('profile.logout')}</h4>
              </div>
              <div className="pro-card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="fw-bold mb-1">{t('profile.logout')}</h6>
                    <p className="text-muted mb-0 small">{t('profile.logoutDescription')}</p>
                  </div>
                  <button
                    className="btn btn-outline-danger btn-sm"
                    onClick={handleLogout}
                  >
                    <i className="fas fa-sign-out-alt me-2"></i>
                    {t('profile.logout')}
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
